const id = {
	'快跟我一起来<br />SuperChinese学中文吧!': 'Ayo belajar bahasa <br />Mandarin bersama SuperChinese!',
	'零基础任性学': 'Belajar Dari Dasar',
	'听说读写全面提升': 'Meningkatkan kemampuan mendengar, berbicara, membaca, dan menulis',
	'趣味对话': 'Percakapan Seru',
	'100+日常对话等你来': '100+ percakapan sehari-hari menanti Anda',
	'智能AI': 'AI Cerdas',
	'个性化学习推荐，由浅入深系统学': 'Rekomendasi pembelajaran yang dapat disesuaikan, belajar dari mudah ke sulit.',
	'趣味对话等你来': 'Percakapan seru menanti Anda',
	'立即打开': 'Buka',
	'我在SuperChinese<br />已累计学习{day}天': 'Saya di SuperChinese<br />Sudah Belajar Selama <span>{day}</span> Hari',
	'我在SuperChinese<br />已连续学习{day}天': 'Saya di SuperChinese<br />Sudah Belajar Selama <span>{day}</span> Hari',
	'学习生词': 'Mempelajari Kosa Kata Baru',
	'学习语法': 'Mempelajari Tata Bahasa',
	'口语练习': 'Melakukan Latihan Berbicara',
	'{n}个': '<span>{n}</span>',
	'{n}次': '<span>{n}</span>kali',
	'点击右上角的按钮,选择在浏览器中打开': 'Klik tombol di kanan atas untuk buka di browser web',
	'邀请码': 'Kode Undangan',
	'用邀请码注册，参与抽大奖': 'Dapatkan kesempatan melakukan undian dengan mengundang teman mendaftar dan memasukkan kode undangan.',
}
export default id;